module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fTtTE"))).then(() => parcelRequire('37nVf'));